//const fft = require('fft-js').fft
const fourier = require("fourier")

export default function make_feature(dataset, bins, binwidth, fft_size, use_fft_size, eps) {
  // data * window (hamming窓)
  for (let i = 0; i < bins; i++) {
    for (let j = 0; j < binwidth; j++) {
      dataset[i][j] = dataset[i][j] * (0.54 - 0.46 * Math.cos(2 * Math.PI * j / (binwidth - 1)))
    }
  }

  /*for (let i = 0; i < bins; i++) {
    for (let j = 0; j < fft_size - binwidth; j++) {
      dataset[i].push(0)
    }
  }*/
  //console.log(fft_size)

  let db_data = []
  let ave_sum = 0.0

  for (let i = 0; i < bins; i++) {
    let tmp = []
    let sum = 0.0

    //let phasors = fft(dataset[i])
    let data_comp = []
    for (let j = 0; j < dataset[i].length; j++) {
      data_comp.push(0)
    }
    // DFT
    let phasors = fourier.dft(dataset[i], data_comp)

    // 絶対値(パワースペクトル)
    for (let j = 0; j < use_fft_size; j++) {
      tmp.push(Math.sqrt(phasors[0][j] * phasors[0][j] + phasors[1][j] * phasors[1][j]))
      sum += tmp[j]
    }

    // NAN発生確認場所
    ave_sum += sum

    // パワースペクトルをsound intensityで正規化
    let mean = sum / use_fft_size
    let tmp2 = []
    for (let j = 0; j < use_fft_size; j++) {
      tmp2.push(tmp[j] / mean)
    }

    // dBに変換
    let tmp3 = []
    for (let j = 0; j < use_fft_size; j++) {
      tmp3.push(10 * Math.log10((tmp2[j] + eps) / eps))
    }
    db_data.push(tmp3)
  }

  ave_sum
  ave_sum = 20 * Math.log10(ave_sum)
  ave_sum = Math.floor(ave_sum);
  //console.log("ave_sum", ave_sum)

  return [db_data, ave_sum]
}